import {
  getAccessToken,
  getSession,
  saveSession,
  forceLogoutForInactiveAccount,
} from './session';

/** Base Nest: /api/v1 (proxy local o URL absoluta en .env) */
export const API_BASE =
  process.env.VUE_APP_API_BASE_URL ||
  process.env.VUE_APP_API_URL ||
  '/api/v1';

let refreshPromise = null;

function isInactiveAccountResponse(status, payload) {
  return status === 403 && payload?.code === 'ACCOUNT_INACTIVE';
}

async function readJsonResponse(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

async function refreshAccessToken() {
  const session = getSession();
  if (!session?.refreshToken) return null;

  const response = await fetch(`${API_BASE}/auth/refresh`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ refreshToken: session.refreshToken }),
  });
  const payload = await readJsonResponse(response);
  if (!response.ok) {
    if (isInactiveAccountResponse(response.status, payload)) {
      forceLogoutForInactiveAccount();
    }
    throw new Error(parseApiError(payload, 'No se pudo renovar la sesión'));
  }

  saveSession({
    ...session,
    user: payload.user || session.user,
    accessToken: payload.accessToken,
    refreshToken: payload.refreshToken,
  });

  return payload.accessToken;
}

export function authHeaders(extra = {}) {
  const accessToken = getAccessToken();
  if (!accessToken) {
    throw new Error('No hay sesión activa');
  }
  return {
    'content-type': 'application/json',
    authorization: `Bearer ${accessToken}`,
    ...extra,
  };
}

export function parseApiError(payload, fallback) {
  if (!payload) return fallback;
  if (typeof payload.message === 'string') return payload.message;
  if (Array.isArray(payload.message)) return payload.message.join(', ');
  return payload.detail || payload.error || fallback;
}

export async function apiFetch(url, options = {}, retry = true) {
  const response = await fetch(url, options);

  if (response.status === 403 && !String(url).includes('/auth/login')) {
    const payload = await readJsonResponse(response.clone());
    if (isInactiveAccountResponse(response.status, payload)) {
      forceLogoutForInactiveAccount();
      return response;
    }
  }

  if (response.status === 401 && retry && !String(url).includes('/auth/login')) {
    try {
      if (!refreshPromise) {
        refreshPromise = refreshAccessToken().finally(() => {
          refreshPromise = null;
        });
      }
      const newToken = await refreshPromise;
      if (newToken) {
        const nextHeaders = {
          ...(options.headers || {}),
          authorization: `Bearer ${newToken}`,
        };
        return apiFetch(url, { ...options, headers: nextHeaders }, false);
      }
    } catch {
      // caller maneja el 401
    }
  }

  return response;
}
